import { FC, useState, useRef } from 'react';
import { Icon } from 'common-components';
import { DropDownProps } from './dropDownTypes';
import styles from './dropDown.module.scss';
import { useOuterClick } from '../../utils';

const DropDown: FC<DropDownProps> = (props: DropDownProps) => {
    const { options, title, isOptionCentered = false, onSelect, optionsStyle = {}, optionStyle = {} } = props;

    const [isOpen, setIsOpen] = useState<boolean>(false);
    const containerRef = useRef() as React.MutableRefObject<HTMLDivElement>;
    const titleRef = useRef<HTMLDivElement>(null);

    useOuterClick(containerRef, () => setIsOpen(false));

    const onOptionClick = option => {
        setIsOpen(false);
        onSelect(option);
    };

    const dropDownItems = () => {
        return (
            <div
                className={styles['options-container']}
                style={{ ...optionsStyle, width: titleRef.current?.offsetWidth }}
            >
                {options.map(option => {
                    return (
                        <div
                            key={option.id}
                            className={styles.option}
                            onClick={() => onOptionClick(option)}
                            style={isOptionCentered ? { justifyContent: 'center' } : {}}
                        >
                            <span className={styles['option-title']} style={optionStyle}>
                                {option.key}
                            </span>
                        </div>
                    );
                })}
            </div>
        );
    };

    return (
        <div className={styles.container} ref={containerRef}>
            <div ref={titleRef} className={styles['title-wrapper']} onClick={() => setIsOpen(!isOpen)}>
                {title}
                <Icon name="adminChevron" style={{ display: 'flex', width: '14px', paddingLeft: '0.2rem' }} />
            </div>
            {isOpen && dropDownItems()}
        </div>
    );
};

export default DropDown;
